export default function About() {
  const features = [
    { icon: 'ri-heart-3-line', text: 'Bajar el ritmo' },
    { icon: 'ri-ear-line', text: 'Escuchar con atención' },
    { icon: 'ri-emotion-line', text: 'Validar emociones' },
    { icon: 'ri-group-line', text: 'Compartir momentos' },
    { icon: 'ri-seedling-line', text: 'Criar desde el amor' }
  ];

  return (
    <section className="py-12 sm:py-16 md:py-24 px-4 sm:px-6 bg-gradient-to-b from-rose-50 to-amber-50">
      <div className="max-w-7xl mx-auto">
        {/* Header */}
        <div className="text-center mb-8 sm:mb-12 md:mb-16">
          <p className="text-orange-600 text-xs sm:text-sm font-bold tracking-widest uppercase mb-3 sm:mb-4">
            ¿Por qué este libro es diferente?
          </p>
          <h2 className="font-serif text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold text-gray-900 mb-6 sm:mb-8 leading-tight max-w-4xl mx-auto">
            En un mundo lleno de prisa,<br />
            este libro es un refugio<br />
            de calma para tu familia
          </h2>
        </div>

        {/* Description */}
        <div className="max-w-3xl mx-auto mb-8 sm:mb-12 md:mb-16">
          <div className="bg-white/80 backdrop-blur-sm rounded-2xl sm:rounded-3xl p-6 sm:p-8 md:p-10 shadow-lg">
            <p className="text-base sm:text-lg md:text-xl text-gray-800 leading-relaxed mb-4 sm:mb-6 font-medium">
              Porque enseña a los niños que son valiosos por lo que son y no por lo que hacen, y acompaña a los padres a criar desde la comprensión y no desde el control.
            </p>
            <div className="flex items-center gap-3 sm:gap-4 text-base sm:text-lg">
              <span className="text-2xl sm:text-3xl">💛</span>
              <p className="text-gray-700 italic font-medium">No busca niños perfectos ni padres perfectos.</p>
            </div>
            <div className="flex items-center gap-3 sm:gap-4 text-base sm:text-lg mt-2 sm:mt-3">
              <span className="text-2xl sm:text-3xl">✨</span>
              <p className="text-gray-700 italic font-bold">Busca conexión real.</p>
            </div>
          </div>
        </div>

        {/* Feature Cards */}
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-3 sm:gap-4 md:gap-6">
          {features.map((feature, index) => (
            <div
              key={index}
              className="bg-white rounded-xl sm:rounded-2xl p-4 sm:p-6 shadow-md hover:shadow-xl transition-all text-center group cursor-pointer hover:scale-105"
            >
              <div className="w-10 h-10 sm:w-12 sm:h-12 md:w-14 md:h-14 flex items-center justify-center mx-auto mb-2 sm:mb-3 md:mb-4 text-emerald-600 text-2xl sm:text-3xl md:text-4xl group-hover:scale-110 transition-transform">
                <i className={feature.icon}></i>
              </div>
              <p className="text-gray-900 font-bold text-xs sm:text-sm md:text-base">{feature.text}</p>
            </div>
          ))}
        </div>

        {/* Additional Message */}
        <div className="text-center mt-8 sm:mt-12 md:mt-16">
          <p className="text-lg sm:text-xl md:text-2xl text-gray-800 font-medium italic max-w-3xl mx-auto">
            Cada página invita a crear momentos genuinos en familia
          </p>
        </div>
      </div>
    </section>
  );
}
